import React, { Suspense } from "react";

import { LoadingModule } from "@/components";

const MacrogeneratorsRoutesLazy = React.lazy(() => import("./MacrogeneratorRoutes"));

export default function RoutesLazy() {
  return (
    <Suspense fallback={<LoadingModule />}>
      <MacrogeneratorsRoutesLazy />
    </Suspense>
  );
}
